import '../css/style.css';

import Alpine from 'alpinejs';
window.Alpine = Alpine;

Alpine.data('onigiriForm', (open = true) => ({
  init() {
    this.adultInput.elm = document.querySelector('[name="r-number-adult"]');
    if (this.adultInput.elm) {
      this.adultInput.value = this.adultInput.elm.value;
      this.adultInput.elm.setAttribute('x-model', 'adultInput.value');
      this.adultInput.elm.addEventListener('keydown', (e) => {
        if (!['ArrowUp', 'ArrowDown', 'Backspace', 'Delete', 'Tab'].includes(e.key) && !/^[0-9]$/.test(e.key)) {
          e.preventDefault();
        }
      });
      this.adultInput.min = this.adultInput.elm.min;
      this.adultInput.max = this.adultInput.elm.max;
    }

    this.childrenInput.elm = document.querySelector('[name="r-number-children"]');
    if (this.childrenInput.elm) {
      this.childrenInput.value = this.childrenInput.elm.value;
      this.childrenInput.elm.setAttribute('x-model', 'childrenInput.value');
      this.childrenInput.elm.addEventListener('keydown', (e) => {
        if (!['ArrowUp', 'ArrowDown', 'Backspace', 'Delete', 'Tab'].includes(e.key) && !/^[0-9]$/.test(e.key)) {
          e.preventDefault();
        }
      });
      this.childrenInput.min = this.childrenInput.elm.min;
      this.childrenInput.max = this.childrenInput.elm.max;
    }

    this.$watch('adultInput.value', (value) => {
      const numberAdult = parseInt(value);

      if (numberAdult > this.maxCombine) {
        this.adultInput.value = this.maxCombine;
        this.childrenInput.value = 0
        return;
      }

      const maxChildren = this.maxCombine - numberAdult;
      this.childrenInput.elm.max = maxChildren;
      this.childrenInput.max = maxChildren;
      if (this.childrenInput.value > maxChildren) {
        this.childrenInput.value = maxChildren;
      }
    });

    this.$watch('childrenInput.value', (value) => {
      const numberChildren = parseInt(value);

      if (numberChildren > this.maxCombine) {
        this.childrenInput.value = this.maxCombine;
        this.adultInput.value = 0;
        return;
      }

      const maxAdult = this.maxCombine - numberChildren;
      this.adultInput.elm.max = maxAdult;
      this.adultInput.max = maxAdult;
      if (this.adultInput.value > maxAdult) {
        this.adultInput.value = maxAdult;
      }
    });
  },
  maxCombine: 6,
  adultInput: {
    elm: null,
    value: 0,
    min: 0,
    max: 0,
  },
  childrenInput: {
    elm: null,
    value: 0,
    min: 0,
    max: 0,
  },
  open: open,
  success: false,
}));

Alpine.start();
